<template>
    <KTeaserCard
        v-if="article"
        :as="NuxtLink"
        :to="`/${fullSlug}`"
        :text="text"
        variant="editorial"
        class="featured-article-card"
    >
        <template #media>
            <KFrame ratio="89 / 40">
                <NuxtImg
                    :src="image.filename"
                    :alt="image.alt"
                    width="712"
                    height="320"
                    fit="cover"
                    format="auto"
                    loading="lazy"
                    sizes="xs:100vw sm:712px md:433px lg:300px"
                />
            </KFrame>
        </template>
        <template #title>
            <span v-html="title" />
        </template>
    </KTeaserCard>
</template>

<script setup>
import { KFrame, KTeaserCard } from '@vemedia/karibu'
import { computed, resolveComponent } from 'vue'
import renderHighlightedText from '~/helpers/renderHighlightedText'
import '~/components/featured-articles/featured-article-card.scss'

// `story` comes from the parent's single batched /api/pages-by-uuids request
// (see featured-articles.vue) — this component no longer fetches per card.
const { item, story } = defineProps(['item', 'story'])

const NuxtLink = resolveComponent('NuxtLink')

const article = computed(() => story || null)

const fullSlug = computed(() => {
    if (!article.value)
        return ''
    return article.value.full_slug
})

const title = computed(() => {
    if (!article.value)
        return ''

    const customTitle = item.title ? renderHighlightedText(item.title) : ''
    if (customTitle)
        return customTitle

    return article.value.content.title
        ? renderHighlightedText(article.value.content.title)
        : article.value.name
})

const text = computed(() => {
    if (!article.value)
        return ''
    return item.text || article.value.content.subtitle
})

const image = computed(() => {
    if (!article.value)
        return {}
    return item.image?.filename ? item.image : article.value.content.image
})
</script>
